/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Plain_Text_Import_Preview_More_BlocksInputs */



/**
* | output |
* | --- |
* | "... ({count} more blocks not shown)" |
*
* @param {Plain_Text_Import_Preview_More_BlocksInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_preview_more_blocks = /** @type {((inputs: Plain_Text_Import_Preview_More_BlocksInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_Preview_More_BlocksInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`... (${i?.count} blocs supplementaires non affiches)`)
	if (locale === "de") return /** @type {LocalizedString} */ (`... (${i?.count} weitere Blöcke nicht angezeigt)`)
	if (locale === "it") return /** @type {LocalizedString} */ (`... (altri ${i?.count} blocchi non mostrati)`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`... (${i?.count} другие блоки не показаны)`)
	if (locale === "es") return /** @type {LocalizedString} */ (`... (${i?.count} bloques más no mostrados)`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`（${i?.count} 更多区块未显示）`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`... (${i?.count} 以上のブロックは表示されません)`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`... (${i?.count} और ब्लॉक नहीं दिखाए गए)`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`... (${i?.count} mais blocos não mostrados)`)
	return /** @type {LocalizedString} */ (`... (${i?.count} more blocks not shown)`)
});